import { IonCard, IonImg, IonText } from "@ionic/react";
import { useIntl } from "react-intl";

import styles from "@components/TextWithAvatar.module.css";

type Props = {
  color: "primary-300" | "secondary-500" | "orange";
  photoUrl?: string | null;
  text: string;
};

const TextWithAvatar = ({ color, photoUrl, text }: Props) => {
  const intl = useIntl();
  return (
    <IonCard className={styles.containerSmall} color={color}>
      {photoUrl && (
        <div className={styles.imageContainer}>
          <IonImg
            alt={intl.formatMessage({ id: "accessibility.altTags.expertPhoto" })}
            className={styles.img}
            src={photoUrl}
          />
        </div>
      )}
      <div className={photoUrl ? styles.leftSpacing : undefined}>
        <IonText>{text}</IonText>
      </div>
    </IonCard>
  );
};

export default TextWithAvatar;
